// @flow
import type { IntlShape } from 'react-intl';
import localizedStrings from 'util/localizedStrings';
import { appVersion } from 'util/constants';

export function isDevEnv() {
  return process.env.NODE_ENV === 'development';
}

export function getHelpVersion() {
  const parts = appVersion.split('.');
  parts.pop();
  return parts.join('.');
}

export function getLocalizedHelpLink({ formatMessage }: IntlShape) {
  return formatMessage(localizedStrings.HELP_URL, {
    version: getHelpVersion(),
  });
}

export function openHelpLink(intl: IntlShape) {
  const url = getLocalizedHelpLink(intl);
  openLink(url);
}

export function openLink(url: string) {
  window.open(url, '_blank');
}



// WEBPACK FOOTER //
// ./src/util/browserUtils.js